import ReviewStarBreakdownBar from './ReviewStarBreakdownBar'

export default ReviewStarBreakdownBar
